import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const MediaIcon: FC<IconProps> = memo(
  ({ width, height, size, color }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(40);
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 40 40"
        fill="none"
      >
        <Path
          d="M33 11H28.1429L26.9857 7.75714C26.9058 7.53524 26.7593 7.34344 26.5662 7.20792C26.3732 7.0724 26.143 6.99979 25.9071 7H14.95C14.4679 7 14.0357 7.30357 13.875 7.75714L12.7143 11H7.85714C6.27857 11 5 12.2786 5 13.8571V30.1429C5 31.7214 6.27857 33 7.85714 33H33C34.5786 33 35.8571 31.7214 35.8571 30.1429V13.8571C35.8571 12.2786 34.5786 11 33 11ZM33.2857 30.1429C33.2857 30.3 33.1571 30.4286 33 30.4286H7.85714C7.7 30.4286 7.57143 30.3 7.57143 30.1429V13.8571C7.57143 13.7 7.7 13.5714 7.85714 13.5714H14.525L15.1357 11.8643L15.9536 9.57143H24.9L25.7179 11.8643L26.3286 13.5714H33C33.1571 13.5714 33.2857 13.7 33.2857 13.8571V30.1429ZM20.4286 15.8571C17.2714 15.8571 14.7143 18.4143 14.7143 21.5714C14.7143 24.7286 17.2714 27.2857 20.4286 27.2857C23.5857 27.2857 26.1429 24.7286 26.1429 21.5714C26.1429 18.4143 23.5857 15.8571 20.4286 15.8571ZM20.4286 25C18.5357 25 17 23.4643 17 21.5714C17 19.6786 18.5357 18.1429 20.4286 18.1429C22.3214 18.1429 23.8571 19.6786 23.8571 21.5714C23.8571 23.4643 22.3214 25 20.4286 25Z"
          fill={color}
        />
      </Svg>
    );
  },
);
